import { createCustomerLocationsService } from "api-client";

/** Relative to `VITE_API_BASE_URL` (e.g. `.../api`). */
const path = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const customerLocationsService = createCustomerLocationsService(path);
